import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Swiper from 'react-id-swiper';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faLongArrowAltRight from '@fortawesome/fontawesome-free-solid/faLongArrowAltRight';
import LocationMap from '../components/LocationMap';
import Config, { googleMapApiKey } from '../config/config';
import './Banner.css';
// import bannerAbout from '../images/demo/ABOUT_BANNER.jpg';
// import bannerCatalog from '../images/demo/PRODUCT_BANNER.png';
// import bannerLocation from '../images/demo/SALES_BANNER.jpg';
// import bannerRegister from '../images/demo/REGISTER_BANNER.png';
// import bannerNews from '../images/demo/NEWS_BANNER.jpg';
// import bannerContact from '../images/demo/CONTACT_BANNER.png';
// import bannerTemp from '../images/demo/TOP_BANNER.jpg';

class Banner extends Component {
  // constructor() {
  //   super();
  //   this.state = {
  //     slideshowData: [],
  //   };
  // }

  // componentWillMount() {
  //   fetch(`${Config.apiUrl}/homeslideshow?_sort=index:asc`)
  //     .then(results => results.json())
  //     .then((data) => {
  //       this.setState({ slideshowData: data });
  //     });
  // }

  render() {
    const slideshowParams = {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      effect: 'fade',
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    };

    let currImage;
    if(this.props.banners){
      let banners = {};
      this.props.banners.forEach((banner) => {
        banners[banner.name] = banner.image;
      });
      currImage = banners[this.props.match.params.page];
    }

    if (this.props.match.params.page === 'locations') {
      return (
        <section className="hero contains-map">
          <div className="hero-body">
            <LocationMap
              isMarkerShown
              googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${googleMapApiKey}`}
              loadingElement={<div className="map-container map-container--loading" />}
              containerElement={<div className="map-container" />}
              mapElement={<div className="map" />}
              locations={this.props.locations}
              filter={this.props.match.params.filter}
            />
          </div>
        </section>
      );
    }
    if (currImage) {
      return (
        <section
          className="image-banner hero is-dark is-medium"
          style={{ backgroundImage: `url(${Config.apiUrl}${currImage.url})`, backgroundSize: 'cover' }}
        >
          <div className="hero-head" />
          <div className="hero-body" />
          <div className="hero-foot">
            <div className="container">
              {/* <h1 className="title">{pageInfo[this.props.match.params.page].title}</h1> */}
              {/* <h2 className="subtitle">{pageInfo[this.props.match.params.page].subtitle}</h2> */}
            </div>
          </div>
        </section>
      );
    }
    return (
      <section className="carousel">
        {this.props.homeslideshows && this.props.homeslideshows.length > 0 && (
          <Swiper {...slideshowParams}>
            {/*
              <div style={{ backgroundImage: `url(${bannerTemp})` }} key={`slide${9999}`}>
                <Link className="button slide-link" to="/catalog/1">
                  <div className="slide-title">最新推出</div>
                  <div className="slide-description">本期商品通通五折</div>
                  <div className="icon">
                    <FontAwesomeIcon className="icon" icon={faLongArrowAltRight} />
                  </div>
                </Link>
              </div>
            */}
            {this.props.homeslideshows.map((elem, idx) => {
              const url = ( elem.image && elem.image[0] ) ? elem.image[0].url : '';
              return (
                <div
                  style={{ backgroundImage: `url(${Config.apiUrl}${url})` }}
                  key={`slide${idx}`}
                >
                  <Link className="button slide-link" to={elem.link} target="_blank" rel="noopener noreferrer">
                    <div className="slide-title">{elem.title}</div>
                    <div className="slide-description">{elem.description}</div>
                    <div className="icon">
                      <FontAwesomeIcon className="icon" icon={faLongArrowAltRight} />
                    </div>
                  </Link>
                </div>
              )
            })}
          </Swiper>
        )}
      </section>
    );
  }
}

Banner.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      page: PropTypes.string,
      filter: PropTypes.string,
    }),
  }),
};

Banner.defaultProps = {
  match: {
    params: {
      page: '',
      filter: '',
    },
  },
};

const mapStateToProps = state => ({
  locations: state.locations,
  banners: state.banners,
  homeslideshows: state.homeslideshows,
});

export default connect(mapStateToProps)(Banner);



// WEBPACK FOOTER //
// ./src/containers/Banner.js